$( document ).on('turbolinks:load', events)

function events() {
  if ($('#debtors-table').length > 0) {
    let url = $('#debtors-table').data('url')
    $.ajax({
      url: url,
      method: 'GET',
      dataType: 'script'
    })
  }
}